import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import StudentSidebar from '../components/StudentSidebar';
import { LogOut } from 'lucide-react';

// Pages
import StudentHome from './student/StudentHome';
import StudentSubjects from './student/StudentSubjects';
import StudentMaterials from './student/StudentMaterials';
import StudentGroupmates from './student/StudentGroupmates';
import StudentProfile from './student/StudentProfile';
import StudentTemperament from './student/StudentTemperament';
import StudentLanguageTest from './student/StudentLanguageTest';
import StudentClubs from './student/StudentClubs';
import StudentCorruption from './student/StudentCorruption';
import StudentLeadership from './student/StudentLeadership';
import StudentEvents from './student/StudentEvents';
import StudentRegulations from './student/StudentRegulations';
import StudentSuicideTest from './student/StudentSuicideTest';

const StudentDashboard = () => {
  const { user, logout } = useAuth();

  const handleLogout = async () => {
    await logout();
  };

  const getInitials = (firstName, lastName) => {
    return `${firstName?.[0] || ''}${lastName?.[0] || ''}`.toUpperCase() || '?';
  };

  return (
    <div className="dashboard-layout">
      <StudentSidebar />
      
      <main className="main-content">
        <header className="main-header">
          <div className="page-title">
            <h1>Buxoro Xalqaro Tibbiyot Texnikumi</h1>
            <p>Talaba portali</p>
          </div>
          
          <div className="user-menu">
            <div className="user-info">
              <div className="name">{user?.first_name} {user?.last_name}</div>
              <div className="role">{user?.role_display}</div>
            </div>
            <div className="user-avatar student">
              {getInitials(user?.first_name, user?.last_name)}
            </div>
            <button className="logout-btn" onClick={handleLogout}>
              <LogOut size={18} />
              Chiqish
            </button>
          </div>
        </header>

        <div className="page-content">
          <Routes>
            <Route path="/" element={<StudentHome />} />
            <Route path="/subjects" element={<StudentSubjects />} />
            <Route path="/subjects/:subjectId/materials" element={<StudentMaterials />} />
            <Route path="/groupmates" element={<StudentGroupmates />} />
            <Route path="/clubs" element={<StudentClubs />} />
            <Route path="/temperament" element={<StudentTemperament />} />
            <Route path="/language" element={<StudentLanguageTest />} />
            <Route path="/leadership" element={<StudentLeadership />} />
            <Route path="/corruption" element={<StudentCorruption />} />
            <Route path="/events" element={<StudentEvents />} />
            <Route path="/regulations" element={<StudentRegulations />} />
            <Route path="/suicide-test" element={<StudentSuicideTest />} />
            <Route path="/profile" element={<StudentProfile />} />
          </Routes>
        </div>
      </main>
    </div>
  );
};

export default StudentDashboard;
